<template>
  <div>
    <Loader no-axios>
      <div class="row">
        <model-index
          ref="table"
          class="col-12"
          :loading="loading"
          v-bind="$props"
          :columns="columns"
          :busy.sync="busy"
          :models-paginated="modelsPaginated"
          :page.sync="page"
          :per-page.sync="perPage"
          :from="from"
          :total="totalFiltered"
          :search.sync="search"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :filter-params.sync="filterParams"
          @create-click="handleCreate"
          @export-click="handleExport"
          @show-click="handleShow"
          @edit-click="handleEdit"
          @delete-click="handleDelete"
        >
          <template #card-title="{}">
            <span class="d-none"></span>
          </template>
          <template #before-table>
            <span class="d-none"></span>
          </template>
        </model-index>
      </div>
    </Loader>
  </div>
</template>
<script>
// import ModelFilter from "@/components/model-filter-v4";
import ModelIndex from "@/router/views/models/index-v3";
import icons from "@/assets/icons";

export default {
  extends: ModelIndex,
  components: {
    // ModelFilter
  },
  props: {
    // cardTitle: {default() { return this.lodash.startCase(this.$t('trips.plural')) }},
    resourceRoute: { default: "unpaid_sale_orders" },
    modelVariable: { default: "unpaid_sale_order" },
    denyCreate: {
      type: Boolean,
      default: true
    },
    hideTableHeader: {
      type: Boolean,
      default: true
    },
    tableHeight: { type: Number, default: 400 },
    tableMinHeight: { type: Number, default: 1 },
    queryKey: {
      type: String,
      default: "unpaid_sale_orders"
    },
    cardAttrs: {
      type: Object,
      default() {
        return {
          bodyClass: "",
          noBody: true,
          class: "border-0"
        };
      }
    },
    saleOrderDueDate: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      icons,
      dayUntilDueOptions: [
        { value: "0", text: `0-10 ${this.lodash.startCase(this.$t("units.days"))}` },
        { value: "11", text: `11-21 ${this.lodash.startCase(this.$t("units.days"))}` },
        { value: "21", text: `21-31 ${this.lodash.startCase(this.$t("units.days"))}` },
        { value: "31", text: `31-40 ${this.lodash.startCase(this.$t("units.days"))}` }
      ],
      selectedDayUntilDue: null,
      title: this.lodash.startCase(this.$t("unpaid_sale_orders.plural")),
      items: [
        {
          text: this.lodash.startCase(this.$t("unpaid_sale_orders.plural")),
          href: "/unpaid_sale_orders",
          active: true
        }
      ],
      sortBy: "date",
      sortDesc: false,
      filterColumns: {
        "ticketable.ticket_id__in": {
          type: Array,
          label: this.lodash.upperFirst(this.$t("tickets.ticket_id")),
          operator: "in",
          input_component: "ticket-multiselect-ajax"
        },
        date__between: {
          type: Array,
          label: this.lodash.upperFirst(this.$t("unpaid_sale_orders.date")),
          operator: "between",
          input_component: "datepicker-range"
        }
      }
    };
  },
  computed: {
    columns() {
      return {
        ["unpaid_sale_order"]: [
          {
            key: "index",
            label: "No",
            tdClass: "align-middle"
          },
          {
            key: "id",
            label: "ID Penjualan",
            tdClass: "align-middle",
            component: {
              props: ["item"],
              template: `
                <router-link
                  :to="{
                    name: 'sale_notes.show',
                    params: { key: item.id }
                  }"
                  target="_blank"
                >
                  {{ item.id }}
                </router-link>
              `
            }
          },
          {
            key: "sales_invoice.due_date",
            label: "Tanggal Jatuh Tempo",
            tdClass: "align-middle",
            formatter: value => {
              return this.$moment(value).format("DD MMM YYYY");
            }
          },
          {
            key: "customer.name",
            label: "Penerima (Pabrik / Trader)",
            tdClass: "align-middle"
          },
          {
            key: "remaining_receivable",
            label: "Potential Inbound",
            tdClass: "align-middle text-end",
            formatter: value => {
              return this.$numeral(value).format("$ 0,0");
            }
          }
        ]
      };
    }
  },
  methods: {
    initFilter(){

    },
    handleShow() {},
    requestConfig(page = 1) {
      return {
        params: {
          page: page,
          per_page: this.perPage,
          search: this.search,
          sort: `sales_invoice.due_date`,
          where_has_sales_invoice_due_date: this.saleOrderDueDate,
          remaining_receivable__gt: 0,
          // payment_status: "unpaid",
          with: "sale_payments,customer,sales_invoice",
          ...this.filterParams
        }
      };
    },
    dummyFetch() {
      return new Promise(resolve => {
        setTimeout(() => {
          const data = [
            {
              date: "2023-11-3",
              total: 1000000,
              count: 3
            },
            {
              date: "2023-11-12",
              total: 500000,
              count: 2
            },
            {
              date: "2023-11-13",
              total: 20000,
              count: 1
            },
            {
              date: "2023-11-23",
              total: 20000,
              count: 1
            },
            {
              date: "2023-12-01",
              total: 20000,
              count: 1
            },
            {
              date: "2023-12-21",
              total: 20000,
              count: 1
            }
          ];
          data.forEach(item => {
            item.day_until_due = this.$moment(item.date).diff(this.$moment(), "days");
          });
          resolve({
            data: {
              data,
              meta: {
                current_page: 1,
                from: 1,
                last_page: 280,
                per_page: "10",
                to: 10,
                total: 2796
              }
            }
          });
        }, 5000);
      });
    },
    fetchModels(page = 1) {
      this.loading = true;
      return this.$axios
        .get(`/sale_orders`, this.requestConfig(page))
        .then(this.handleResponse)
        .catch(error => {
          this.failedAlert(error);
          return null;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleResponse(response) {
      const {
        data: { data, meta }
      } = response;
      this.models = data;
      this.page = Number(meta.current_page);
      this.perPage = Number(meta.per_page);
      this.from = Number(meta.from);
      this.total = Number(meta.total);

      this.stats = [];

      return response;
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/design/app";

::v-deep {
  .table-model {
    @extend .jds-table;
    table {
      @extend .table-zebra;
      @extend .table-borderless;
    }
    overflow-y: auto !important;
  }
}
</style>
